"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Schema = _interopRequireDefault(require("./Schema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const API = "https://kompass.dimu.org/admin/api";

class SchemaWithState extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      formData: {},
      language: "no"
    });

    _defineProperty(this, "uploadFile", (uploadUrl, file, data, onUpdate) => {
      console.log('example:uploadFile', uploadUrl);
      let payload = new FormData();
      payload.append('file', file);
      var xhr = new XMLHttpRequest();
      xhr.upload.addEventListener("progress", event => this.uploadProgress(event, data, onUpdate), false);
      xhr.addEventListener("load", event => this.uploadProgress(event, data, onUpdate), false); //  xhr.addEventListener("error", uploadFailed, false);
      //  xhr.addEventListener("abort", uploadCanceled, false);

      xhr.open("POST", uploadUrl);
      xhr.send(payload);
    });

    _defineProperty(this, "uploadProgress", (event, data, onUpdate) => {
      let progress, media;

      if (event.lengthComputable) {
        media = {
          mediaType: data && data.mediaType
        };
        progress = Math.round(event.loaded * 100 / event.total);
      } else {
        media = data;
        progress = 100;
      }

      console.log('example:uploadProgress', progress);
      onUpdate({
        mediaId: data.uniqueId,
        media: media,
        uploadProgress: progress
      });
    });

    _defineProperty(this, "receiveUploadUrl", (file, data, onAdd, onUpdate) => {
      console.log('example:receiveUploadUrl', data);
      const uniqueId = data.uniqueId,
            uploadUrl = data.uploadUrl;

      if (uniqueId && uploadUrl) {
        onAdd({
          mediaId: data.uniqueId,
          media: data
        });
        this.uploadFile(uploadUrl, file, data, onUpdate);
      }
    });

    _defineProperty(this, "requestUploadUrl", (file, onAdd, onUpdate) => {
      console.log('example:requestUploadUrl', file);
      const type = file.type,
            name = file.name;
      let data = {
        title: name,
        content: {
          title: name,
          filename: name
        }
      };
      const payload = JSON.stringify(data);
      let url = API + '/media/upload';

      if (type.startsWith('image')) {
        url = url + '/image';
      } else if (type.startsWith('video')) {
        url = url + '/video';
      } else if (type.startsWith('audio')) {
        url = url + '/audio';
      } else {
        url = url + '/misc';
      }

      fetch(url, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json; charset=utf-8"
        },
        body: payload
      }).then(response => response.json(), error => console.log('An error occurred.', error)).then(data => this.receiveUploadUrl(file, data, onAdd, onUpdate));
    });

    _defineProperty(this, "onUpload", upload => {
      console.log('example:onUpload', upload);
      const acceptedFiles = upload.acceptedFiles,
            onAdd = upload.onAdd,
            onUpdate = upload.onUpdate;
      acceptedFiles.forEach(file => {
        this.requestUploadUrl(file, onAdd, onUpdate);
      });
    });

    _defineProperty(this, "onChange", newState => {
      console.log('example:onChange', newState);
      this.setState(_extends({}, newState));
    });

    _defineProperty(this, "onSubmit", ({
      formData,
      errors
    }) => {
      console.log('example:onSubmit', formData);
      this.setState({
        formData: formData,
        errors: errors
      });
    });

    _defineProperty(this, "renderErrors", () => {
      const errors = this.state.errors;

      if (errors) {
        return _react.default.createElement("ul", {
          style: {
            border: "1px solid",
            margin: "10px",
            padding: "10px"
          }
        }, errors.map(error => {
          return _react.default.createElement("li", null, JSON.stringify(error));
        }));
      }
    });
  }

  componentDidMount() {
    this.setState({
      formData: this.props.formData
    });
  }

  render() {
    const _this$props = this.props,
          schema = _this$props.schema,
          uiSchema = _this$props.uiSchema;
    const _this$state = this.state,
          formData = _this$state.formData,
          errors = _this$state.errors;
    return _react.default.createElement("div", null, _react.default.createElement(_Schema.default, _extends({}, this.props, {
      formData: formData,
      onChange: this.onChange,
      onSubmit: this.onSubmit,
      onUpload: this.onUpload
    })), _react.default.createElement("p", null, "errors"), this.renderErrors(errors), _react.default.createElement("p", null, "formData:"), JSON.stringify(formData), _react.default.createElement("p", null, "schema:"), JSON.stringify(schema), _react.default.createElement("p", null, "uiSchema:"), JSON.stringify(uiSchema));
  }

}

_defineProperty(SchemaWithState, "defaultProps", {
  formData: {}
});

var _default = SchemaWithState;
exports.default = _default;
module.exports = exports.default;